module.exports = __webpack_public_path__ + "img/2243.985ac551.gif";